<script>
    import {twMerge} from "tailwind-merge";
    import {default as PaymentCardIcon} from "$m7-library/component/Icons/PaymentCard.svelte";

    const {
        method,
        selected = false,
        disabled = false,
        onselect = () => {},
    } = $props();

    // Server-side unavailability flag (e.g. EasyCredit when delivery ≠ billing
    // and not a Packstation). Method stays visible but is rendered as disabled
    // with the reason as a hint so users understand WHY they can't pick it.
    const unavailable = $derived(method.metadata?.unavailable === true);
    const unavailableReason = $derived(method.metadata?.unavailableReason ?? '');
    const isDisabled = $derived(disabled || unavailable);

    const cls = $derived(twMerge(
        "w-full text-left p-4 rounded-lg border-2 transition-colors flex items-center gap-3",
        isDisabled && "opacity-50 cursor-not-allowed",
        !isDisabled && (selected
            ? "border-green bg-green/5 cursor-pointer"
            : "border-gray-102 bg-white hover:border-gray-103 cursor-pointer"),
    ));

    const iconUrl = $derived.by(() => {
        const name = method.iconUrl ?? '';
        if (!name) return '';
        if (name.startsWith('http') || name.startsWith('/')) return name;
        // decision: [1]
        return `/out/m7-apex/img/${name}`;
    });
</script>

<button
    class={cls}
    onclick={() => !isDisabled && onselect(method.id)}
    type="button"
    disabled={isDisabled}
    data-payment-option={method.id}
    data-select-nameed={selected}
    data-checkout-payment-unavailable={unavailable ? method.id : null}
    title={unavailable ? unavailableReason : null}
    aria-disabled={isDisabled}
>
    <span class="shrink-0 size-5 rounded-full border-2 flex items-center justify-center"
          class:border-green={selected}
          class:border-gray-102={!selected}>
        {#if selected}
            <span class="size-2.5 rounded-full bg-green"></span>
        {/if}
    </span>
    {#if iconUrl}
        <img src={iconUrl} alt="" class="h-5 w-auto shrink-0 object-contain"/>
    {:else}
        <PaymentCardIcon class="shrink-0 h-5 w-5"/>
    {/if}
    <span class="flex flex-col min-w-0">
        <span class="font-bold text-xsm text-black">{method.title}</span>
        {#if method.iconSuffix}
            <span class="text-xs text-gray-103">{method.iconSuffix}</span>
        {/if}
        {#if unavailable && unavailableReason}
            <span class="text-xs text-gray-103 mt-1" data-checkout-payment-unavailable-reason={method.id}>
                {unavailableReason}
            </span>
        {/if}
    </span>
</button>
